import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0f0f10]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <p className="font-display uppercase text-2xl tracking-tight">
          The Point <span className="text-[#ccff00]">Strategy Hub</span>
        </p>
        <p className="text-white/50 mt-4 max-w-sm leading-relaxed">
          A premium tennis complex demo. Every booking and membership here is simulated — no payments, no commitments, all fun.
        </p>
      </div>
      <div>
        <p className="text-[#ccff00] uppercase tracking-widest text-xs mb-4">Explore</p>
        <div className="flex flex-col gap-3 text-white/70">
          <Link to="/courts" className="hover:text-white transition-colors">Courts</Link>
          <Link to="/coaching" className="hover:text-white transition-colors">Coaching</Link>
          <Link to="/membership" className="hover:text-white transition-colors">Membership</Link>
          <Link to="/my-booking" className="hover:text-white transition-colors">My Booking</Link>
          <Link to="/members" className="hover:text-white transition-colors">Member Wall</Link>
          <Link to="/assistant" className="hover:text-white transition-colors">AI Assistant</Link>
          <Link to="/admin" className="hover:text-white transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
      <div>
        <p className="text-[#ccff00] uppercase tracking-widest text-xs mb-4">The Club</p>
        <p className="text-white/70 leading-relaxed">
          1 Match Point Avenue<br />
          Open daily 07:00 – 23:00<br />
          hello@thepointstrategyhub.com
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-white/40 text-sm">
      © {new Date().getFullYear()} The Point Strategy Hub — fictional demo site.
    </div>
  </footer>
);

export default Footer;
